import { Draft, PayloadAction } from '@reduxjs/toolkit';
import { IAnalysesState } from '../types';
import { QueryType } from '../../../../utils/apollo/graphqlSchema';
import { assertCondition } from '../../../../utils/types';

export const selectPredictionKind = (
  draft: Draft<IAnalysesState>,
  action: PayloadAction<{
    id: string;
    kind: any;
  }>,
) => {
  const { id, kind } = action.payload;
  const chartData = draft[id].chartData;
  assertCondition(chartData?.queryType === QueryType.Prediction);
  chartData.data.selectedValue = kind;
  return;
};
